import { combineEpics, Epic, ofType } from 'redux-observable';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '../../actions';
import { changeLocation } from '../../actions/common';
import {
    PRICE_PACKAGES_NAVIGATION_GO_TO_FILTER,
    PricePackagesNavigationGoToFilterAction
} from '../../actions/pricePackages';
import { serializeFilterToString } from '../../service/FilterHelpers/FilterHelpers';
import { EpicDeps } from '../../service/StoreFactory';
import { UrlHelpers } from '../../service/UrlHelpers';
import { PricePackagesScreenUrlSearchParams } from '../../typings/pricePackages';
import { State } from '../../typings/state';

export const pricePackagesNavigationGoToFilterEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(PRICE_PACKAGES_NAVIGATION_GO_TO_FILTER),
        mergeMap(
            (action: PricePackagesNavigationGoToFilterAction): Observable<Action> => {
                const { pathname, query = {} } = store$.value.router;

                const newFilter = serializeFilterToString(action.expressions);

                if (newFilter !== query.filter) {
                    return of(
                        changeLocation(
                            pathname,
                            UrlHelpers.normalizeQuery({
                                [PricePackagesScreenUrlSearchParams.filter]: newFilter
                            })
                        )
                    );
                }
                return EMPTY;
            }
        )
    );
};

export const pricePackagesNavigationEpic = combineEpics(pricePackagesNavigationGoToFilterEpic);
